import styled from "@emotion/styled"
import { Box, Grid, Link as MuiLink } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { EmailIcon, PhoneIcon } from "src/shared"
import Text from "src/shared/Text"
import TopFotterImg from "../TopFotterImg"

const Link = styled(MuiLink)(() => ({
  textDecoration: "none",
  fontSize: 18,
  fontWeight: 400,
  color: "#fff",
}))

const FooterInfo = () => {
  return (
    <Box width="100%">
      <TopFotterImg />
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        sx={theme => ({
          [theme.breakpoints.up(640)]: {
            flexDirection: "row",
          },
          [theme.breakpoints.down(750)]: {
            padding: theme.spacing(3, 2),
          },
          [theme.breakpoints.down(450)]: {
            padding: theme.spacing(2),
          },
        })}
        padding={theme.spacing(5)}
        bgcolor="#3AAE2A"
        color="white"
      >
        <Box width="100%">
          <Grid
            mb={0.5}
            container
            sx={{
              [theme.breakpoints.down(700)]: {
                "& > p": {
                  fontSize: 16,
                  lineHeight: "21px",
                },
              },
              [theme.breakpoints.down(400)]: {
                "& > p": {
                  fontSize: 14,
                  lineHeight: "18px",
                },
              },
            }}
            columnGap={1}
            rowGap={0.5}
          >
            <Link href="https://www.facebook.com/gkitchenvn">Facebook</Link> |
            <Link href="https://gkitchen.com.vn/cua-hang">
              Danh sách cửa hàng
            </Link>
            | <Link href="https://gkitchen.com.vn/san-pham">Mua Online</Link>
          </Grid>
          <Box
            display="flex"
            gap={2}
            flexWrap="wrap"
            justifyContent="space-between"
            width="100%"
          >
            <Box>
              <Text
                sx={{
                  [theme.breakpoints.down(700)]: {
                    lineHeight: "28px",
                    fontSize: 22,
                  },
                }}
                fontSize={24}
                fontWeight={700}
              >
                CÔNG TY TNHH GREENIFIQUE
              </Text>
              <Text
                sx={{
                  [theme.breakpoints.down(700)]: {
                    fontSize: 16,
                    lineHeight: "21px",
                  },
                }}
                fontSize={18}
                fontWeight={400}
              >
                72-74 Nguyễn Thị Minh Khai, P.Võ Thị Sáu, Q.3, Tp.HCM
                <br />
                Mã số doanh nghiệp: 0316957596 <br />
                Giấy chứng nhận đăng ký kinh doanh cấp ngày 12/09/2021
              </Text>
            </Box>
            <Box>
              <Text
                sx={{
                  [theme.breakpoints.down(700)]: {
                    fontSize: 22,
                    lineHeight: "28px",
                  },
                }}
                fontWeight={800}
              >
                LIÊN HỆ
              </Text>
              <Grid
                sx={{
                  [theme.breakpoints.down(700)]: {
                    fontSize: 16,
                    lineHeight: "21px",
                  },
                }}
                container
                gap={1}
                alignItems="center"
              >
                <PhoneIcon />
                Hotline: 1900 1708
              </Grid>
              <Grid
                sx={{
                  [theme.breakpoints.down(700)]: {
                    fontSize: 16,
                    lineHeight: "21px",
                  },
                }}
                container
                gap={1}
                alignItems="center"
              >
                <EmailIcon />
                Email: info@feddy.com.vn
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box width="100%">
        <Link href="https://seysolutions.com">
          <Text
            lineHeight="3.5"
            fontSize={13}
            textAlign="center"
            color="#166938"
          >
            Copyright © 2023 SEY SOLUTIONS
          </Text>
        </Link>
      </Box>
    </Box>
  )
}

export default FooterInfo
